import React from 'react';
import { motion as Motion } from 'framer-motion';
import { siteData } from '../data';
import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const Lunch = () => {
  return (
    <div>
      <section className="grid grid-cols-1 lg:grid-cols-2 items-stretch bg-zinc-950 overflow-hidden">
        <Motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          className="flex flex-col justify-center px-4 pt-32 pb-20 lg:pt-40 lg:pb-32 lg:pl-[calc((100vw-1280px)/2+1rem)] lg:pr-24"
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 uppercase tracking-tight">{siteData.lunch.title}</h1>
          <p className="text-xl text-zinc-400 mb-8 max-w-xl">{siteData.lunch.description}</p>
          <div className="prose prose-zinc mb-10 max-w-xl">
            <p className="text-zinc-400 leading-relaxed">
              {siteData.lunch.content}
            </p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-xl">
            {siteData.lunch.features.map((feature) => (
              <div key={feature} className="flex items-center gap-4">
                <Check className="h-8 w-8 text-white stroke-[2.5px]" />
                <span className="text-zinc-300 font-medium">{feature}</span>
              </div>
            ))}
          </div>

          <div>
            <Link 
              to="/kontakt" 
              className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full font-bold hover:bg-white/10 hover:-translate-y-1 transition-all duration-300 shadow-lg"
            >
              Få et uforpligtende tilbud <ArrowRight className="h-5 w-5" />
            </Link>
          </div>
        </Motion.div>

        <Motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="relative min-h-[500px] lg:min-h-0"
        >
          <img 
            src={siteData.lunch.image} 
            alt="Frokostordning" 
            className="absolute inset-0 w-full h-full object-cover"
          />
        </Motion.div>
      </section>
    </div>
  );
};

export default Lunch;
